import { IBaseComponentProps, MoneyFormatter } from 'namirasoft-site-react';
import Styles from './NSPPayDetail.module.css';

export interface NSPPayDetailProps extends IBaseComponentProps
{
	payable?: number;
	disccount?: number;
	tax?: number;
	total?: number;
	paid?: number;
	balance?: number;
	currency: string;
}
function NSPPayDetail(props: NSPPayDetailProps)
{
	return (
		<div className={Styles.nsp_pay_detail}>
			<div>
				<p>Payable:</p>
				<p>Discount:</p>
				<p>Tax:</p>
				<p>Total:</p>
				<p>Paid:</p>
				<p>Balance:</p>
			</div>
			<div className={Styles.nsp_right_row}>
				<p >{new MoneyFormatter(undefined, props.currency).format(props.payable)}</p>
				<p >{new MoneyFormatter(undefined, props.currency).format(props.disccount)}</p>
				<p >{new MoneyFormatter(undefined, props.currency).format(props.tax)}</p>
				<p >{new MoneyFormatter(undefined, props.currency).format(props.total)}</p>
				<p style={{ color: props.balance === 0 ? "green" : "unset" }} >{new MoneyFormatter(undefined, props.currency).format(props.paid)}</p>
				<p style={{ color: props.balance === 0 ? "green" : "unset" }} >{new MoneyFormatter(undefined, props.currency).format(props.balance)}</p>
			</div>
		</div>
	);
}

export default NSPPayDetail;